/** Cabeçalhos trocados entre clientes e API. */
export const HTTP_HEADERS = {
  company: 'X-Company-Id',
  client: 'X-Client',
  device: 'X-Device-Id',
  appVersion: 'X-App-Version',
  requestId: 'X-Request-Id',
} as const;

/** Valor do cabeçalho de empresa que pede todas as empresas acessíveis. */
export const ALL_COMPANIES = 'ALL';

/**
 * `web`: o painel, autenticado por cookies httpOnly. `app`: cliente nativo,
 * que recebe os tokens no corpo e manda o access token no Authorization.
 */
export const CLIENT_TYPES = ['web', 'app'] as const;
export type ClientType = (typeof CLIENT_TYPES)[number];

export const AUTH_COOKIES = {
  /** JWT de acesso, httpOnly, enviado em toda chamada à API. */
  access: 'base_access',
  /** Token de refresh, httpOnly, só vai para as rotas de auth. */
  refresh: 'base_refresh',
  /** Sinal legível (sem segredo) de que há sessão: usado pelo proxy do painel. */
  session: 'base_session',
} as const;

export const REFRESH_COOKIE_PATH = '/api/auth';

/** Motivos que a API devolve no corpo do 401 para o cliente decidir o que fazer. */
export const AUTH_REJECTION_REASONS = {
  tokenMissing: 'token_missing',
  tokenInvalid: 'token_invalid',
  tokenExpired: 'token_expired',
  sessionLegacy: 'session_legacy',
  sessionNotFound: 'session_not_found',
  sessionRevoked: 'session_revoked',
  sessionExpired: 'session_expired',
  deviceBlocked: 'device_blocked',
  refreshInvalid: 'refresh_invalid',
  refreshReused: 'refresh_reused',
  loginLocked: 'login_locked',
} as const;

export type AuthRejectionReason =
  (typeof AUTH_REJECTION_REASONS)[keyof typeof AUTH_REJECTION_REASONS];
